module.exports = __webpack_public_path__ + "Frame403-ca1cc6e8.webp";